document.addEventListener('DOMContentLoaded', function(){

    const dropZones = document.querySelectorAll('.Dropzone');

    dropZones.forEach(zone => {

        const labelTextElem = zone.querySelector('.DropzoneLabelText'); // get label text element
        const labelTextDefaultMessage = labelTextElem.textContent; // default message
        const input = zone.querySelector('.DropzoneInput'); // get input element
        const errorMessageElement = zone.querySelector('.DropzoneErrorMessage'); // get error message element
        const fileSizeLimit = Number(input.getAttribute('data-file-size-limit')); // get file size limit in MB

        input.addEventListener('dragover', function(){
            // add class when dragging over
            zone.classList.add('dragover');
        });

        input.addEventListener('dragleave', function(){
            // remove class when dragging out
            zone.classList.remove('dragover');
        });

        input.addEventListener('drop', function(){
            // remove class when dropping
            zone.classList.remove('dragover');
        });

        // when input changes
        input.addEventListener('change', () => {

            // clear errors
            errorMessageElement.innerText = '';

            // display default message
            labelTextElem.textContent = labelTextDefaultMessage;

            // no files? return
            if ( !input.files.length ) return;

            // array for file names
            const fileNames = [];

            // array for files that are too big
            const failedFiles = [];

            // loop through files
            for ( const file of input.files )
            {
                // file size check
                const filesize = ((file.size/1024)/1024).toFixed(4); // file size in MB
                if ( fileSizeLimit && filesize > fileSizeLimit )
                {
                    // push file name for error
                    failedFiles.push( { name: file.name, size: filesize } );
                }
                else
                {
                    // push file name for display
                    fileNames.push(file.name);
                }
            }

            if ( failedFiles.length ) {
                // we have failed files
                let failMessage = '';

                // set up error message
                failedFiles.forEach(failedFile => {
                    failMessage += `Soubor <em>${failedFile.name}</em> je příliš velký (<em>${failedFile.size}MB</em>)<br />`;
                });

                // show error message
                errorMessageElement.innerHTML = failMessage;

                // clear file input so it doesn't submit
                input.value = null;
            }
            else
            {
                // all good, show file names for submit
                labelTextElem.textContent = fileNames.join(', ');
            }

        });

    });

});